import React from 'react';
import t from '~t';

import { Button } from '~ui';

export default function PickerIconReset({ onLink }) {
  const onClick = (e) => {
    e.preventDefault();
    onLink('');
  };

  return (
    <Button asChild variant='link'>
      <a href='' onClick={onClick}>
        {t.s('remove')}
      </a>
    </Button>
  );
}
